import PhotoBoxList from "./Boxes/PhotoBoxList";
import SquareList from "./Squares/SquareList";
import CirclesList from "./Circles/CirclesList";
import MessageBoardList from "./Messages/MessageBoard";
import PhotoList from "./List/PhotoList";
import ColloageList from "./Collage/SquareCollageList";
import DynamicList from './Dynamic/DynamicList';
import ContentAndDocs from './ContentAndDocs/ContentAndDocs';

import { ContentShowListProps } from './ContentShow.interface';
import { LISTS } from './ListNames.Interfaces';

interface Props extends ContentShowListProps {
    ContentShowType: string;
}

const ListViewComponent: React.FC<Props> = (props) => {

    const { ContentShowType } = props;

    if (ContentShowType === LISTS.SQUARES) return <SquareList {...props} />;

    if (ContentShowType === LISTS.CIRCLES) return <CirclesList {...props} />;

    if (ContentShowType === LISTS.COLLAGE) return <ColloageList {...props} />;

    if (ContentShowType === LISTS.BOXES) return <PhotoBoxList {...props} />;

    if (ContentShowType === LISTS.MESSAGES) return <MessageBoardList {...props} />;

    if (ContentShowType === LISTS.DYNAMIC) return <DynamicList {...props} />;

    if (ContentShowType === LISTS.CONTENT_AND_DOCS) return <ContentAndDocs {...props} />;

    // Default
    return <PhotoList {...props} />;

}

export default ListViewComponent;
